import APIService from '@/services/APIService.js';

export default {
  getExecucoes(includeExpiredRecords) {
    return APIService.apiCall().get(`/conformidadeObras/getExecucoes/${includeExpiredRecords}`);
  },

  getConfigCriacao() {
    return APIService.apiCall().get('/conformidadeObras/getConfigCriacao');
  },

  uploadArquivo(postData) {
    return APIService.apiCall().post('/conformidadeObras/uploadArquivo', postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  salvar(postData) {
    return APIService.apiCall().post('/conformidadeObras/salvar', JSON.stringify(postData));
  },

  executar(id) {
    return APIService.apiCall().get(`/conformidadeObras/executar/${id}`);
  },

  baixarPlanilha(id, config = {}) {
    return APIService.apiCall().get(`/conformidadeObras/baixarPlanilha/${id}`, {
      responseType: 'blob',
      ...config
    });
  },

  download(id, config = {}) {
    return this.baixarPlanilha(id, config);
  },

  deletar(id) {
    return APIService.apiCall().get(`/conformidadeObras/excluir/${id}`);
  }
};
